import { getCurrentLanguageId, displayError, addEventListenerIfNotExists } from "./common";
import HttpClient from "./http-client";
import LoadingIndication from "./loading-indication";

export default class Form {
    private url: string;
    private formElement: HTMLFormElement;
    private onSuccess: (response: string) => void;
    private onModelError: (response: string) => void;

    constructor(
        url: string,
        form: HTMLFormElement,
        onSucess: (response: string) => void = null,
        onModelError: (response: string) => void = null
    ) {
        this.url = url;
        this.formElement = form;
        this.onSuccess = onSucess;
        this.onModelError = onModelError;
    }

    subscribeAndProcess(): void {
        addEventListenerIfNotExists(this.formElement, 'submit', async (event: Event) => {
            await this.process(event);
        });
    }

    async process(event: Event): Promise<void> {
        event.preventDefault();

        const formData = new FormData(this.formElement);
        LoadingIndication.show(this.formElement);

        const response = await new HttpClient().fetch(this.url, {
            method: "POST",
            headers: {
                "Current-Language-Id": getCurrentLanguageId(),
                requestUrl: window.location.href
            },
            body: formData
        }, (e) => this.handleError(e));

        if(response.redirected) {
            await this.handleRedirect(response);
        } else {
            LoadingIndication.hide(this.formElement);
        }

        if (response.ok) {
            typeof this.onSuccess === "function" && this.handleSuccess(response);
        }
    }

    private handleError(e: Response|string): void {
        const response = e as Response;
        if(response?.status === 400){
            this.handleModelError(response);
        }
        else {
            displayError(response?.statusText ?? e as string);
        }
        LoadingIndication.hide(this.formElement);
    }

    private async handleModelError(response: Response): Promise<void> {
        const validatedViewComponent = await response.text();
        typeof this.onModelError === "function" &&
            this.onModelError(validatedViewComponent);
    }

    private async handleRedirect(response: Response): Promise<void> {
        const redirectUrl = await response.url;
        window.location.href = redirectUrl;
    }

    private async handleSuccess(response: Response): Promise<void> {
        const htmlContent = await response.text();
        typeof this.onSuccess === "function" &&
            this.onSuccess(htmlContent);
    }
}
